export default __webpack_public_path__ + "static/media/SPONSOR-Lions.3785f96a.svg";